import { StatementType } from "./index.js";
import { isAddValue, isAlterTableAddOnly, isCommaToken, isConstraintValue, isExistsValue, isForeignValue, isIfValue, isIndexValue, isKeyValue, isLeftParentToken, isNewStatement, isNotValue, isPeriodToken, isPrimaryValue, isRightParentToken, isSemicolonToken, isStringToken, isTableValue, isUniqueValue, matchKeyModifiers, matchUsingIndexName } from "../helper.js";
import { indexColumnsParser } from "./index.columns.js";
//#region ../schema-sql-parser/dist/parser/statement/alter.table.add.unique.js
function alterTableAddUniqueParser(tokens, $pos) {
	const newStatement = isNewStatement(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isString = isStringToken(tokens);
	const isComma = isCommaToken(tokens);
	const isAdd = isAddValue(tokens);
	const isConstraint = isConstraintValue(tokens);
	const isPeriod = isPeriodToken(tokens);
	const isTable = isTableValue(tokens);
	const isUnique = isUniqueValue(tokens);
	const isPrimary = isPrimaryValue(tokens);
	const isForeign = isForeignValue(tokens);
	const isKey = isKeyValue(tokens);
	const isIndex = isIndexValue(tokens);
	const isIf = isIfValue(tokens);
	const isNot = isNotValue(tokens);
	const isExists = isExistsValue(tokens);
	const isLeftParent = isLeftParentToken(tokens);
	const isRightParent = isRightParentToken(tokens);
	const keyModifiers = matchKeyModifiers(tokens);
	const usingIndexName = matchUsingIndexName(tokens);
	const isOnly = isAlterTableAddOnly(tokens)($pos.value);
	const isToken = () => $pos.value < tokens.length;
	const skipGroup = () => {
		let depth = 0;
		while (isToken() && !isSemicolon($pos.value)) {
			if (isLeftParent($pos.value)) depth++;
			else if (isRightParent($pos.value) && --depth === 0) {
				$pos.value++;
				return;
			}
			$pos.value++;
		}
	};
	const keys = [];
	let name = "";
	let constraintName = "";
	let clauseKey = null;
	let columnClause = false;
	$pos.value++;
	if (isTable($pos.value)) {
		$pos.value++;
		if (isOnly) $pos.value++;
		if (isString($pos.value)) {
			name = tokens[$pos.value].value;
			$pos.value++;
			while (isPeriod($pos.value)) {
				if (!isString($pos.value + 1)) {
					$pos.value++;
					break;
				}
				name = tokens[$pos.value + 1].value;
				$pos.value += 2;
			}
		}
	}
	while (isToken() && !newStatement($pos.value)) {
		if (isSemicolon($pos.value)) {
			$pos.value++;
			break;
		}
		if (isComma($pos.value) || isAdd($pos.value)) {
			constraintName = "";
			clauseKey = null;
			columnClause = false;
			$pos.value++;
			continue;
		}
		if (isLeftParent($pos.value)) {
			skipGroup();
			continue;
		}
		if (isConstraint($pos.value)) {
			$pos.value++;
			if (isString($pos.value) && !isUnique($pos.value) && !isPrimary($pos.value) && !isForeign($pos.value)) {
				constraintName = tokens[$pos.value].value;
				$pos.value++;
			}
			continue;
		}
		if (isUnique($pos.value)) {
			$pos.value++;
			if (columnClause) {
				constraintName = "";
				continue;
			}
			if (isKey($pos.value) || isIndex($pos.value)) $pos.value++;
			if (isIf($pos.value) && isNot($pos.value + 1) && isExists($pos.value + 2)) $pos.value += 3;
			$pos.value += keyModifiers($pos.value);
			let keyName = constraintName;
			constraintName = "";
			if (isString($pos.value)) {
				keyName = tokens[$pos.value].value;
				$pos.value++;
				$pos.value += keyModifiers($pos.value);
			}
			if (isLeftParent($pos.value)) {
				const columns = indexColumnsParser(tokens, $pos);
				if (columns.length) {
					clauseKey = {
						type: StatementType.alterTableAddUnique,
						name,
						constraintName: keyName,
						usingIndexName: "",
						columns
					};
					keys.push(clauseKey);
				}
			}
			continue;
		}
		const usingIndex = usingIndexName($pos.value);
		if (usingIndex) {
			if (clauseKey) clauseKey.usingIndexName = tokens[$pos.value + usingIndex - 1].value;
			$pos.value += usingIndex;
			continue;
		}
		columnClause = true;
		$pos.value++;
	}
	return keys;
}
//#endregion
export { alterTableAddUniqueParser };
